import * as XLSX from 'xlsx';

// Header rows must match each backend bulk-upload service's REQUIRED_HEADERS
// exactly - same text, same order (the backend does a strict equality check
// on the header row).
const TEMPLATES = {
  examCentre: {
    fileName: 'exam-centre-upload-template.xlsx',
    headers: ['Center Name', 'Location', 'Center Number'],
  },
  students: {
    fileName: 'students-upload-template.xlsx',
    headers: [
      'Student Name',
      'Email',
      'Program',
      'Exam Centre',
      'Registration Number',
      'Year of Study',
      'Semester',
      'Status',
    ],
  },
  programs: {
    fileName: 'programs-upload-template.xlsx',
    headers: ['Program Name', 'Program Code', 'Program Category'],
  },
  programCategories: {
    fileName: 'program-categories-upload-template.xlsx',
    headers: ['Category Name', 'Code', 'Description'],
  },
  modules: {
    fileName: 'modules-upload-template.xlsx',
    headers: ['Module Name', 'Module Code', 'Exam Type', 'Program', 'Year Of Study', 'Semester'],
  },
  users: {
    fileName: 'users-upload-template.xlsx',
    headers: [
      'Full Name',
      'Username',
      'Contact NO',
      'Email',
      'Password',
      'Address OF Institution',
      'Role',
      'User Category',
    ],
  },
};

// The scoring guide upload is parsed by content, not a fixed header row -
// it mirrors the printed UVTAB scoring guide: a "Question N" row opens a
// group, lettered rows beneath it are the criteria (Part, Assessment
// Criteria, Scoring Guide, Max Score Process, Max Score Product), each
// group ends with Sub-Total/TOTAL SCORE rows, and the table ends at
// GRAND TOTAL. See ScoringCriterionService.bulkUpload on the backend.
function buildScoringGuideTemplateRows() {
  return [
    ["Delete the example question below and replace it with your own. Keep the row pattern: a 'Question N' row, its lettered criteria rows, then Sub-Total and TOTAL SCORE rows - repeat for each question, ending with a GRAND TOTAL (%) row."],
    [],
    ['S/N', 'ASSESSMENT CRITERIA', 'SCORING GUIDE', 'MAX SCORE PROCESS (P)', 'MAX SCORE PRODUCT (R)'],
    ['', 'Question One'],
    ['(a)', 'Created a class called BMI.', 'The class was defined correctly.', 1, 4],
    ['(b)', 'Created a utility method called bodyMassIndexCalculator.', 'The method was defined correctly.', 1, 4],
    ['', 'Sub-Total', '', 2, 8],
    ['', 'TOTAL SCORE = PROCESS+PRODUCT', '', 10],
    ['', 'Question Two'],
    ['(a)', '...', '...', 0, 0],
    ['', 'Sub-Total', '', 0, 0],
    ['', 'TOTAL SCORE = PROCESS+PRODUCT', '', 0],
    ['', 'GRAND TOTAL (%)', '', 100],
  ];
}

export function downloadBulkUploadTemplate(type) {
  if (type === 'scoringGuide') {
    const worksheet = XLSX.utils.aoa_to_sheet(buildScoringGuideTemplateRows());
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Template');
    XLSX.writeFile(workbook, 'scoring-guide-template.xlsx');
    return;
  }
  const config = TEMPLATES[type];
  if (!config) {
    throw new Error(`Unknown bulk upload template type: ${type}`);
  }
  const rows = [config.headers, ...(config.sampleRows || [])];
  const worksheet = XLSX.utils.aoa_to_sheet(rows);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Template');
  XLSX.writeFile(workbook, config.fileName);
}
